<template>
  <v-container fluid>
    <v-card class="mt-2 px-5 pt-4 pb-3">
      <v-card-title>Caixa</v-card-title>
      <v-flex class="ml-2">PELOS PRÓXIMOS 4 MESES, QUAL O VALOR TOTAL EM CAIXA E A RECEBER?</v-flex>
      <v-text-field class="mb-4" outlined placeholder="0.00" prefix="R$ " v-money="money"
        v-model.lazy="answers.crisisBudget"></v-text-field>
      <v-divider />
      <v-card-title>Despesas</v-card-title>
      <v-flex class="ml-2">QUAL O CUSTO MENSAL COM ALUGUEL? </v-flex>
      <v-text-field outlined placeholder="0.00" prefix="R$ " v-money="money" v-model.lazy="answers.rentValue">
      </v-text-field>
      <v-flex class="ml-2">QUAL O CUSTO MENSAL COM FOLHA DE SALÁRIOS</v-flex>
      <v-text-field class="mb-2" outlined placeholder="0.00" prefix="R$ " v-money="money"
        v-model.lazy="answers.staffValue"></v-text-field>
      <v-flex class="ml-2">QUAL O CUSTO MENSAL COM OPERAÇÃO?</v-flex>
      <v-text-field class="mb-2" outlined placeholder="0.00" prefix="R$ " v-money="money"
        v-model.lazy="answers.materialValue"></v-text-field>
      <v-flex class="ml-2">QUAL O CUSTO MENSAL COM IMPOSTOS?</v-flex>
      <v-text-field class="mb-2" outlined placeholder="0.00" prefix="R$ " v-money="money"
        v-model.lazy="answers.taxesValue"></v-text-field>
      <v-flex class="ml-2">QUAL O CUSTO MENSAL COM DÍVIDAS?</v-flex>
      <v-text-field class="mb-2" outlined placeholder="0.00" prefix="R$ " v-money="money"
        v-model.lazy="answers.debtsValue"></v-text-field>
      <v-flex class="ml-2">QUAL O VALOR MENSAL COM OUTRAS DESPESAS?</v-flex>
      <v-text-field outlined placeholder="0.00" prefix="R$ " v-money="money" v-model.lazy="answers.otherValue">
      </v-text-field>
    </v-card>
    <v-btn large dark block @click="calculate()" class="mt-8 mb-6">
      CALCULAR</v-btn>
  </v-container>
</template>

<script>
  import {
    VMoney
  } from 'v-money';
  import {
    mask
  } from 'vue-the-mask';

  export default {
    name: 'Home',
    directives: {
      mask,
      money: VMoney
    },
    beforeRouteEnter(to, from, next) {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;

      next();
    },
    data() {
      return {
        money: {
          decimal: '.',
          thousands: '',
          prefix: '',
          suffix: ' ',
          precision: 2,
          masked: false /* doesn't work with directive */
        },
        // -------------------------------------------------
        // ----------------------------------------- Answers
        answers: {
          isEssential: null,
          crisisBudget: null,
          rentValue: 0.0,
          staffValue: 0.0,
          meterialValue: 0.0,
          taxesValue: 0.0,
          debtsValue: 0.0,
          otherValue: 0.0,
        }
        // -------------------------------------------------
      }
    },
    created() {
      this.answers = {
        isEssential: null,
        crisisBudget: null,
        rentValue: 0.0,
        staffValue: 0.0,
        meterialValue: 0.0,
        taxesValue: 0.0,
        debtsValue: 0.0,
        otherValue: 0.0,
      }
    },
    methods: {
      calculate() {
        this.$store.state.deadline = null;
        this.$store.state.generalIndex = 0.0;
        this.$store.state.values = [];
        this.$store.state.rentHealth = 0.0;
        this.$store.state.staffHealth = 0.0;
        this.$store.state.materialHealth = 0.0;
        this.$store.state.taxesHealth = 0.0;
        this.$store.state.debtsHealth = 0.0;
        this.$store.state.otherHealth = 0.0;

        let flowTotal = parseFloat(this.answers.rentValue) + parseFloat(this.answers.staffValue) + parseFloat(this
            .answers.meterialValue) + parseFloat(this.answers.taxesValue) + parseFloat(this.answers.debtsValue) +
          parseFloat(this.answers.otherValue);
        this.$store.state.generalIndex = (parseFloat(this.answers.crisisBudget) / (flowTotal * 4));

        let calculatedValues = [];
        let diff = parseFloat(this.answers.crisisBudget);

        for (let i = 0; i < 4; i++) {
          let percent = diff / flowTotal;
          diff = diff - flowTotal;
          calculatedValues.push(percent);
        }

        this.$store.state.values = calculatedValues;

        this.$store.state.rentHealth = ((parseFloat(this.answers.rentValue) * 4) / (parseFloat(this.answers
          .crisisBudget)) * 100).toFixed(0);
        this.$store.state.staffHealth = ((parseFloat(this.answers.staffValue) * 4) / (parseFloat(this.answers
          .crisisBudget)) * 100).toFixed(0);
        this.$store.state.materialHealth = ((parseFloat(this.answers.materialValue) * 4) / (parseFloat(this.answers
          .crisisBudget)) * 100).toFixed(0);
        this.$store.state.taxesHealth = ((parseFloat(this.answers.taxesValue) * 4) / (parseFloat(this.answers
          .crisisBudget)) * 100).toFixed(0);
        this.$store.state.debtsHealth = ((parseFloat(this.answers.debtsValue) * 4) / (parseFloat(this.answers
          .crisisBudget)) * 100).toFixed(0);
        this.$store.state.otherHealth = ((parseFloat(this.answers.otherValue) * 4) / (parseFloat(this.answers
          .crisisBudget)) * 100).toFixed(0);

        this.$ga.event('Virtus', 'click', 'resum', true);

        this.$router.push({
          name: 'resum'
        });
      }
    }
  }
</script>